var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.ind"),
              type: "index",
              width: "80px",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.Operator"),
              width: "180px",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(_vm.createUser[scope.row.createUser])),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("operationCenter.operationTime"),
              "min-width": "180px",
              prop: "createTime",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.Classification"),
              "min-width": "140px",
              prop: "operateType",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          scope.row.operateType === 1
                            ? _vm.$t("CenterForSorting.add")
                            : _vm.$t("CenterForSorting.modify")
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.ActionContent"),
              "min-width": "200px",
              prop: "operateType",
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm.operationType === 2
                        ? _c("div", [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CenterForSorting.StateTwoCode")
                                ) +
                                  "：" +
                                  _vm._s(scope.row.areaData.twoCode)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      _vm.operationType === 5
                        ? _c("div", [
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CenterForSorting.StateTwoCode")
                                ) +
                                  "：" +
                                  _vm._s(scope.row.areaData.twoCode)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("orderCenterCont.city")) +
                                  "：" +
                                  _vm._s(scope.row.areaData.name)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("basicData.zipCode")) +
                                  "：" +
                                  _vm._s(scope.row.areaData.zipCode)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("mdfeTranslate.IBGECode")) +
                                  "：" +
                                  _vm._s(scope.row.areaData.ibge)
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                "ISS：" +
                                  _vm._s(
                                    scope.row.areaData.issTaxation
                                      ? scope.row.areaData.issTaxation + "%"
                                      : ""
                                  )
                              ),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(_vm.$t("placeOrder.area")) +
                                  "：" +
                                  _vm._s(
                                    scope.row.areaData.regionalLevelName
                                      ? scope.row.areaData.regionalLevelName
                                      : ""
                                  )
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.queryParam.pageNumber,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.queryParam.pageSize,
              total: _vm.total,
              background: "",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryParam, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryParam, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryParam, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryParam, "pageSize", $event)
              },
              "current-change": _vm.getCurrencyTableData,
              "size-change": _vm.getSizeTableData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }